export const getIsCookieSettingsOpen = (state) => state.cookieSettings.open;

export const getIsGlobalCookieSettingsIconShown = (state) => state.cookieSettings.globalCookieIconShown;
